export default __webpack_public_path__ + "static/media/back_button.cc7c292b.png";